import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LogoWordmark } from "../components/Logo";
import { Footer } from "../components/Footer";
import { useLang, STR, pathForLang } from "../i18n";

// Il loader Iubenda e' in index.html e si attiva al load della pagina:
// scansiona il DOM e sostituisce questo link con il documento legale completo.
// Se il JS fallisce, il link resta valido e apre la policy sul sito Iubenda.
const IubendaEmbed = ({ url, title, testid }) => (
  <a
    href={url}
    className="iubenda-white iubenda-noiframe iubenda-embed iub-body-embed"
    title={title}
    data-testid={testid}
  >
    {title}
  </a>
);

const Shell = ({ title, updated, children, testid }) => {
  const { lang } = useLang();
  const { pathname } = useLocation();
  const t = STR[lang];

  return (
  <div data-testid={testid}>
    <header className="bg-white border-b border-[#edf0f2]" data-testid="legal-header">
      <div className="max-w-[1320px] mx-auto flex items-center justify-between px-6 h-[104px]">
        <Link to={lang === "en" ? "/en/" : "/"} data-testid="legal-logo-link">
          <LogoWordmark compact />
        </Link>
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-1 text-[11px] font-bold tracking-[0.08em]" data-testid="lang-switch">
            {["it", "en"].map((l) => (
              <a
                key={l}
                href={pathForLang(pathname, l)}
                hrefLang={l}
                data-testid={`lang-${l}`}
                className={`px-2 py-1 uppercase transition-colors duration-300 ${
                  lang === l ? "text-[#F18A00]" : "text-[#0D1B2A]/40 hover:text-[#0D1B2A]"
                }`}
              >
                {l}
              </a>
            ))}
          </div>
          <Link
            to={lang === "en" ? "/en/" : "/"}
            className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.045em] text-[#0D1B2A] border border-[#0D1B2A] px-5 py-3 hover:border-[#F18A00] hover:text-[#F18A00] transition-colors duration-300"
            data-testid="legal-back-link"
          >
            <ArrowLeft size={14} /> {t.legal.back}
          </Link>
        </div>
      </div>
    </header>
    <main className="bg-white py-[75px]">
      <div className="max-w-[860px] mx-auto px-6">
        <p className="text-[11px] uppercase tracking-[0.2em] text-[#F18A00] font-bold">Project Works — Studio Tecnico Associato</p>
        <h1 className="font-display font-medium text-[34px] md:text-[40px] tracking-[-0.02em] text-[#0D1B2A] mt-[7px]" data-testid="legal-title">
          {title}
        </h1>
        <span className="block w-[38px] h-0.5 bg-[#F18A00] mt-[15px]" aria-hidden="true" />
        <p className="text-xs text-[#9aa6ae] mt-4">{t.legal.updated}: {updated}</p>
        <div className="mt-10 text-sm leading-[1.7] text-[#4A4F55]">{children}</div>
      </div>
    </main>
    <Footer />
  </div>
  );
};

export const PrivacyPolicy = () => {
  const { lang } = useLang();
  return (
    <Shell title="Privacy Policy" updated={lang === "it" ? "agosto 2026" : "August 2026"} testid="privacy-page">
      <IubendaEmbed
        url="https://www.iubenda.com/privacy-policy/8139714"
        title="Privacy Policy"
        testid="iubenda-embed-privacy"
      />
    </Shell>
  );
};

export const CookiePolicy = () => {
  const { lang } = useLang();
  return (
    <Shell title="Cookie Policy" updated={lang === "it" ? "agosto 2026" : "August 2026"} testid="cookie-page">
      <IubendaEmbed
        url="https://www.iubenda.com/privacy-policy/8139714/cookie-policy"
        title="Cookie Policy"
        testid="iubenda-embed-cookie"
      />
    </Shell>
  );
};
